import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Register.css';
import api from '../api';

function Register() {
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [avatarFile, setAvatarFile] = useState(null);
	const [region, setRegion] = useState('');
	// default role for reporter registration (sent to backend)
	const [role] = useState('reporter');
	const [pressRole, setPressRole] = useState('Reporter');
	const [dob, setDob] = useState('');
	const [bloodGroup, setBloodGroup] = useState('');
	const [address, setAddress] = useState('');
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		try {
			// send multipart/form-data if avatar provided
			let res;
			if (avatarFile) {
				const form = new FormData();
				form.append('name', name);
				form.append('email', email);
				form.append('password', password);
				form.append('region', region);
				form.append('dob', dob);
				form.append('bloodGroup', bloodGroup);
				form.append('address', address);
				form.append('role', role);
				form.append('pressRole', pressRole);
				form.append('avatar', avatarFile);
				res = await api.post('/api/auth/register-reporter', form, { headers: { 'Content-Type': 'multipart/form-data' } });
			} else {
				res = await api.post('/api/auth/register-reporter', { name, email, password, region, dob, bloodGroup, address, role, pressRole });
			}
			const data = res && res.data ? res.data : null;
			if (data && data.success) {
				alert('Registered as reporter. Await superadmin approval.');
				navigate('/admin/signin');
			} else {
				alert((data && data.message) || 'Registration failed');
			}
		} catch (err) {
			if (err.response && err.response.data && err.response.data.message) alert(err.response.data.message);
			else alert('Error: ' + (err.message || 'Request failed'));
		} finally {
			setLoading(false);
		}
	};

	return (
			<div className="auth-page">
				<div className="auth-card container">
					<h2>Reporter Register</h2>
							<form onSubmit={handleSubmit} className="auth-form">
								<div className="form-group">
									<label htmlFor="reg-name">Full name</label>
									<input id="reg-name" className="fancy-input" value={name} onChange={e => setName(e.target.value)} placeholder="Full name" required />
								</div>
								<div className="form-group">
									<label htmlFor="reg-email">Email</label>
									<input id="reg-email" className="fancy-input" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" required />
								</div>
								<div className="form-group">
									<label htmlFor="reg-pass">Password</label>
									<input id="reg-pass" className="fancy-input" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" type="password" required />
								</div>
								<div className="form-group">
									<label htmlFor="reg-region">Region / City</label>
									<input id="reg-region" className="fancy-input" value={region} onChange={e => setRegion(e.target.value)} placeholder="E.g. Moradabad" />
								</div>
								<div className="form-group custom-file">
									<label>Profile Photo (for ID card)</label>
									<input id="reg-avatar" type="file" accept="image/*" onChange={e=>setAvatarFile(e.target.files && e.target.files[0])} />
									<label htmlFor="reg-avatar" className={`file-label ${avatarFile ? 'selected' : ''}`}>Choose Photo</label>
									<span className="file-name">{avatarFile ? avatarFile.name : 'No file chosen'}</span>
								</div>
								<div className="form-group">
									<label htmlFor="reg-pressrole">Role / Designation (for press card)</label>
									<input id="reg-pressrole" className="fancy-input" value={pressRole} onChange={e => setPressRole(e.target.value)} placeholder="E.g. Reporter Tehsil Bilari" required />
								</div>
								<div className="form-group">
									<label htmlFor="reg-dob">Date of Birth</label>
									<input id="reg-dob" className="fancy-input" value={dob} onChange={e => setDob(e.target.value)} placeholder="DD/MM/YYYY or YYYY-MM-DD" />
								</div>
								<div className="form-group">
									<label htmlFor="reg-blood">Blood Group</label>
									<input id="reg-blood" className="fancy-input" value={bloodGroup} onChange={e => setBloodGroup(e.target.value)} placeholder="A+, B-, O+, etc." />
								</div>
								<div className="form-group">
									<label htmlFor="reg-address">Address</label>
									<textarea id="reg-address" className="fancy-input" value={address} onChange={e => setAddress(e.target.value)} placeholder="Permanent address for ID card" />
								</div>
								<button type="submit">Register</button>
							</form>
					<div className="auth-footer">Already registered? <Link to="/admin/signin">Login here</Link></div>
				</div>
			
			{loading && (
				<div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
					<div className="loading">
						<div className="spinner"></div>
					</div>
				</div>
			)}
		</div>
	);
}

export default Register;
